"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getService = exports.Service = exports.Util = exports.formatRequest = exports.ensurePromise = exports.DBotsError = exports.Constants = exports.Poster = void 0;
var Service_1 = require("./Interface/Service");
Object.defineProperty(exports, "Service", { enumerable: true, get: function () { return Service_1.Service; } });
var Poster_1 = require("./Interface/Poster");
Object.defineProperty(exports, "Poster", { enumerable: true, get: function () { return Poster_1.Poster; } });
exports.Constants = __importStar(require("./Utils/Constants"));
exports.DBotsError = __importStar(require("./Utils/DBotsError"));
var EnsurePromise_1 = require("./Utils/EnsurePromise");
Object.defineProperty(exports, "ensurePromise", { enumerable: true, get: function () { return EnsurePromise_1.ensurePromise; } });
var FormatRequest_1 = require("./Utils/FormatRequest");
Object.defineProperty(exports, "formatRequest", { enumerable: true, get: function () { return FormatRequest_1.formatRequest; } });
exports.Util = __importStar(require("./Utils/Util"));
exports.getService = Service_1.Service.get;
